export default "__VITE_ASSET__9219b84d__"